/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShipmentStatusRequest = {
    /**
     * One of the 6 execution statuses
     */
    executionStatus: ShipmentStatusRequest.executionStatus;
};
export namespace ShipmentStatusRequest {
    /**
     * One of the 6 execution statuses
     */
    export enum executionStatus {
        PROGRESS = 'progress',
        READY_FOR_DEPARTURE = 'ready_for_departure',
        IN_TRANSIT = 'in_transit',
        ARRIVED = 'arrived',
        CLEARANCE_TRANSPORT = 'clearance_transport',
        DELIVERED = 'delivered',
    }
}

